import styled from '@emotion/styled'
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'
import { theme } from '../../themes/theme'

const Calendar = styled(DateCalendar)`
  .MuiButtonBase-root.MuiPickersDay-root.Mui-selected {
    color: ${theme.colors.primaryButton.text};
    background-color: ${theme.colors.primaryButton.background};
  }

  .MuiYearCalendar-button.Mui-selected {
    color: ${theme.colors.primaryButton.text};
    background-color: ${theme.colors.primaryButton.background};
  }

  .MuiPickersCalendarHeader-labelContainer {
    font-family: ${theme.fonts.body} !important;
  }

  .MuiYearCalendar-button {
    font-family: ${theme.fonts.body} !important;
  }

  .MuiButtonBase-root {
    font-family: ${theme.fonts.body} !important;
  }
`

export { Calendar }
